var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"width":"20%","label-col":4,"wrapper-col":14,"footer":null,"visible":_vm.open},on:{"cancel":_vm.onClose}},[_c('video',{attrs:{"src":this.dataUrl,"width":"100%","height":"150","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }